module.exports = __webpack_public_path__ + "img/ae10cdc5-8e12-4d46-a608-d05843389b7f.91b3e237.webp";